export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyAMkXY7kYiv4_vFyqqZn3WaasWeqceS4-8",
        authDomain: "ps-rittergasse-0q6m.firebaseapp.com",
        databaseURL: "https://ps-rittergasse-0q6m-default-rtdb.firebaseio.com",
        projectId: "ps-rittergasse-0q6m",
        storageBucket: "ps-rittergasse-0q6m.appspot.com",
        messagingSenderId: "381703464170",
        appId: "1:381703464170:web:fe989d74fd6d663a656393",
        measurementId: "G-QN2VEEQBXG"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts